import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

// modules
import styles from '../Containers.module.scss';

class PrivacyPolicy extends PureComponent {
  render() {
    return (
      <Container fluid className={styles.PrivacyPolicy}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to="/about">
                <BreadcrumbItem active>Privacy Policy</BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <Container>
          <h2>Privacy Policy</h2>
          <p>Last Updated: July 1, 2018</p>

          <p>
            This Privacy Policy applies to your use of the M.L.S. of Naples, Inc. ("NAPLES
            MLS") operated website at www.naplesarea.com (as defined below). &nbsp;Please
            see our&nbsp;European Economic Area (EEA) Privacy Policy&nbsp;(set forth
            below) for information about: (i) how NAPLES MLS processes your Personal Data
            if you are located in the EU and how we provide you with individual services
            or are subject to monitoring; or (ii) any other processing by a NAPLES MLS
            entity where the EU General Data Protection Regulation would otherwise apply.
          </p>

          <p>
            This Privacy Policy applies to Personal Information collected by NAPLES MLS ("
            <b>NAPLES MLS</b>," "<b>we</b>" or "<b>us</b>") through www.naplesarea.com and
            any other website, application or digital service on or to which this Privacy
            Policy is linked or referenced (collectively, the "<b>Services</b>"). This
            Privacy Policy does not apply to our data collection practices conducted
            offline. Unless we notify you, this Privacy Policy does not apply to any
            third-party website or service that you may access through the Services.
          </p>

          <p>
            This Privacy Policy is incorporated into and made part of our Terms of Use.
            &nbsp;Please read this Privacy Policy and our Terms of Use carefully. When you
            submit Personal Information to us, you consent to the collection, use and
            disclosure of your Personal Information as described in this Privacy Policy.
          </p>

          <p>
            <b>
              IF YOU DO NOT AGREE WITH ANY PART OF THIS PRIVACY POLICY OR OUR TERMS OF
              USE, PLEASE DO NOT USE OUR WEBSITE AND ONLINE SERVICES.
            </b>
          </p>

          <p>
            <b>
              1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CHANGES
              TO THIS PRIVACY POLICY
            </b>
          </p>

          <p>
            The Effective Date of this Privacy Policy is set forth at the top of this
            webpage. As business needs change, we may amend this Privacy Policy. If we
            materially change the way we collect, use or disclose your Personal
            Information, we will notify you in advance through the Services and offer you
            the opportunity to opt out and delete your Personal Information. The amended
            Privacy Policy supersedes all previous versions. Your continued use of the
            Services after the Effective Date constitutes your acceptance of the amended
            Privacy Policy.
          </p>

          <p>
            <b>
              2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;INFORMATION
              WE MAY COLLECT
            </b>
          </p>

          <p>
            When you use the Services, we may collect two types of information: Personal
            Information and Usage Data.
          </p>

          <p>
            In this Privacy Policy, "<b>Personal Information</b>" means any information
            that identifies or could be used to identify an individual, such as the
            following:
          </p>

          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Name</p>
          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Postal address</p>
          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Telephone number</p>
          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Email address</p>

          <p>
            Personal Information does not include either (i) aggregated information to the
            extent that an individual's identity cannot reasonably be derived from it, or
            (ii) publicly available information that has not been combined with non-public
            Personal Information.
          </p>

          <p>
            We define "<b>Usage Data</b>" as information about an individual's activity on
            or through the Services that, by itself, does not reasonably identify the
            individual, such as the following:
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Browser and operating system information
          </p>

          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Computer or device type</p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Time spent navigating certain webpages
            or connected via mobile applications
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Information collected through Data
            Collection Technologies (as defined below)
          </p>

          <p>
            Generally, we do not consider Usage Data as Personal Information, because
            Usage Data by itself usually does not identify an individual. However, in some
            jurisdictions, Usage Data may be considered Personal Information because it
            can be used to make inferences about you.
          </p>

          <p>
            <b>
              3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;COLLECTION,
              USE AND DISCLOSURE OF PERSONAL INFORMATION
            </b>
          </p>

          <p>
            We collect, use and disclose Personal Information for all lawful purposes in
            the operation and conduct of our business.
          </p>

          <p>
            <b>How We May Collect Personal Information</b>
          </p>

          <p>
            We and our service providers may collect Personal Information through your use
            of the Services, such as when you register with us, participate in surveys and
            questionnaires, apply for employment, or subscribe to newsletters and blog
            updates. &nbsp;We also may collect the Personal Information that you publish
            or display on public areas of the Services, such as any NAPLES MLS entity's
            blog (collectively, "<b>User Contributions</b>"). Your User Contributions are
            made publicly available at your own risk. &nbsp;We do not control the actions
            of third parties that access your User Contributions.
          </p>

          <p>
            <b>Through Social Media:&nbsp;</b>Certain Services may link to social media
            platforms and plug-ins, such as Facebook and Twitter (collectively, "
            <b>Social Media</b>"). When accessing the Services through a Social Media
            account, we may (depending on the applicable user privacy settings)
            automatically receive information from that Social Media platform. We may
            collect and use this information for the purposes described in this Privacy
            Policy or as described at the time the information was collected.
          </p>

          <p>
            <b>Through Mobile Applications:&nbsp;</b>We may offer mobile applications ("
            <b>Apps</b>") as part of the Services or at certain events hosted by NAPLES
            MLS parent or subsidiary entities. When we offer Apps, we may collect
            information about your use of and interaction with the Apps, such as operating
            system type, browser type, domain and other system settings, search queries,
            the country and time zone in which the mobile device or tablet is located,
            metadata and other information associated with other files stored on your
            device. &nbsp;We also may collect information about the location of the mobile
            device or tablet used to access the Services ("<b>Location Data</b>").
            &nbsp;Location Data includes: (i) the location of the mobile device or tablet
            derived from GPS or WiFi use, (ii) the IP address of the mobile device or
            tablet or internet service used to access the Services, and (iii) other
            information made available by a user or others that indicates the current or
            prior location of the user, such as geotag information in photographs. If you
            do not want us to collect Location Data from your device, please delete the
            App or disable the location settings on your device or tablet. &nbsp;Note,
            however, that disabling the location setting may affect your ability to access
            and use an App.
          </p>

          <p>
            <b>How We May Use Personal Information</b>
          </p>

          <p>
            We may use Personal Information for the purposes described at the time of its
            collection or as described in this Privacy Policy. For example, we may use
            Personal Information as follows:
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;To confirm registrations, respond to
            your inquiries or fulfill your requests, or to email you materials you
            requested.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; To send you information, such as
            business updates and event announcements, that we think may interest you.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; To allow you to send Services-related
            content through the Services.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; If you contact us through the Services,
            to keep a record of your contact information and correspondence to use when
            responding to you.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; To notify you about important
            information regarding changes to our terms, conditions and policies.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; To analyze use of the Services to help
            us detect problems, prevent fraud, identify usage trends and improve user
            experience.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; If you apply for employment with us, to
            process your employment application and other related activities only.
          </p>

          <p>
            <b>How We May Disclose Personal Information</b>
          </p>

          <p>We may disclosure your Personal Information as follows:</p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>With your consent.&nbsp;&nbsp; </b>We may disclose your Personal
            Information to any party for whom your consent has been provided. &nbsp;For
            example, we may disclose your Personal Information to anyone to whom you send
            messages through the Services.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>To our affiliated entities.&nbsp; &nbsp;</b>We may disclose your Personal
            Information among NAPLES MLS entities as stated on the Legal Notices/Imprint
            section below for the purposes described in this Privacy Policy and as
            required by law. &nbsp;&nbsp;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>To our service providers.&nbsp;&nbsp; </b>We may disclose information with
            third-party service providers that support our operations, through services
            such as registering and hosting webcast and live events, and employee
            recruitment.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>In relation to a corporate transaction.&nbsp;&nbsp; </b>We may disclose and
            transfer Personal Information if we are involved in a merger, sale,
            acquisition, divestiture, restructuring, reorganization, dissolution,
            bankruptcy, or other change of ownership or control (whether in whole or in
            part).
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>As we believe to be necessary and appropriate.&nbsp;&nbsp; </b>We may also
            disclose Personal Information: (i) as permitted by law; (ii) if we determine
            that the disclosure of specific information is necessary to comply with the
            request of a law enforcement or regulatory agency or other legal process;
            (iii) to protect the legitimate rights, privacy, property, interests or safety
            of our company or our affiliated entities&nbsp;customers, business partners,
            employees or the general public; (iv) to pursue available remedies or limit
            damages; (v) to enforce our Terms of Use; and (vi) to respond to an emergency.
          </p>

          <p>
            <b>
              4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;COLLECTION,
              USE AND DISCLOSURE OF USAGE DATA
            </b>
          </p>

          <p>
            We collect, use and disclose Usage Data for all lawful purposes in the
            operation and conduct of our businesses.
          </p>

          <p>
            <b>How We May Collect Usage Data</b>
          </p>

          <p>
            When you use the Services, including Apps, we and our service providers may
            collect the Usage Data that is collected by most browsers or automatically
            through your device. When you download and use an App, we and our service
            providers may track and collect App data, including when you accessed our
            servers and what information and file have been downloaded. &nbsp;We also
            collect Usage Data through our use of Data Collection Technology. &nbsp;For
            more information about how we use Data Collection Technology, including
            cookies, please review Section 5 below.
          </p>

          <p>
            <b>How We May Use and Disclose Usage Data</b>
          </p>

          <p>
            We may use and disclose Usage Data for any purpose, except where we are
            required to do otherwise under applicable law. &nbsp;If we are required to
            treat certain types of Usage Data as Personal Information under applicable
            law, we use and disclose it as described in Section 3 above.
          </p>

          <p>
            In some instances, we may combine Usage Data with Personal Information (such
            as your device ID with your name). If we combine any Usage Data with Personal
            Information, the combined information will be treated by us as Personal
            Information as long as it is combined and can be used to identify you.
          </p>

          <p>
            <b>
              5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;COOKIES
              AND OTHER DATA COLLECTION TECHNOLOGY
            </b>
          </p>

          <p>
            We refer to cookies, web beacons (also known as pixel tags and clear GIFs) and
            other similar technology as "<b>Data Collection Technology</b>."
          </p>

          <p>
            A&nbsp;<b>cookie</b>&nbsp;is a small text file that is sent to or accessed
            from your web browser or your computer's hard drive. A cookie typically
            contains the name of the domain (internet location) from which the cookie
            originated, the "lifetime" of the cookie (when it expires), and a randomly
            generated unique number or other similar identifier. A cookie may also contain
            information about your computer, such as user settings, browsing history and
            activities conducted while using the Services. &nbsp;A&nbsp;<b>web beacon</b>
            &nbsp;(also called a&nbsp;<b>pixel tag</b>&nbsp;or&nbsp;
            <b>clear GIF</b>) is a piece of computer code that enables us to monitor user
            activity and website traffic. &nbsp;To learn more about cookies and web
            beacons, visit&nbsp;www.allaboutcookies.org.
          </p>

          <p>
            <b>How We Use Data Collection Technology:</b>&nbsp;&nbsp; Data Collection
            Technology helps us improve your experience of the Services. &nbsp;In
            particular, we use analytics cookies to compile statistics about the use of
            the Services, help us analyze technical and navigational information about the
            services, and detect and prevent fraud. &nbsp;We also may use Data Collection
            Technology to collect information from the computer or device that you use to
            access the Services, such as your operating system type, browser type, domain
            and other system settings, as well as the language your system uses and the
            country and time zone in which your computer or device is located.
          </p>

          <p>
            <b>Your Control of Cookies:&nbsp;&nbsp; </b>Some web browsers (including some
            mobile web browsers) provide settings that allow you to control or reject
            cookies or alert you when a cookie is placed on your computer or device.
            &nbsp;You may also be able to reject mobile device identifiers by activating
            the appropriate setting on your mobile device. &nbsp;Although you are not
            required to accept cookies or mobile device identifiers, if you block or
            reject them, you may not have access to all features available through the
            Services.
          </p>

          <p>
            <b>Our Policy on Do Not Track Signals:&nbsp; &nbsp;</b>Some web browsers
            incorporate a "Do Not Track" ("<b>DNT</b>") or similar feature that signals to
            websites that a user does not want to have his or her online activity and
            behavior tracked. &nbsp;If a website that responds to a particular DNT signal
            receives the DNT signal, the browser can block that website from collecting
            certain Personal Information about the browser's user. We follow the DNT
            signals we receive from your browsers.
          </p>

          <p>
            <b>
              6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CHOICES
              AND ACCESS
            </b>
          </p>

          <p>
            <b>Marketing Emails:&nbsp; &nbsp;</b>If you do not wish to receive
            marketing-related emails from us, please click the unsubscribe link at the
            bottom of a marketing email, or email us at&nbsp;gdpr.compliance@nabor.com.
          </p>

          <p>
            <b>Access Requests:&nbsp;&nbsp; </b>You may request access to any of your
            Personal Information that you have previously provided to us through the
            Services.&nbsp; You may also request that we update, modify or delete your
            Personal Information that we have collected.&nbsp; Please contact us by email
            at&nbsp;ebennabor.com&nbsp;to exercise these rights.
          </p>

          <p>
            Please note that we cannot remove or modify your Personal Information from the
            databases of third parties to which we have disclosed your information prior
            to your opt-out or access request. &nbsp;Please contact those third parties
            directly.
          </p>

          <p>
            <b>
              7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SPECIAL
              NOTICE TO CALIFORNIA RESIDENTS
            </b>
          </p>

          <p>
            California Civil Code Section 1798.83 permits individual California residents
            to request certain information regarding our disclosure of certain categories
            of Personal Information to third parties for those third parties' direct
            marketing purposes. &nbsp;To make such a request, please contact us at
            gdpr.compliance@nabor.com. &nbsp;This request may be made no more than once
            per calendar year. &nbsp;We reserve our right not to respond to requests
            submitted other than to the email or mailing addresses specified in this
            Section.
          </p>

          <p>
            <b>
              8.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LINKS
              TO OTHER WEBSITES AND SERVICES
            </b>
          </p>

          <p>
            The Services may include links to third-party websites and services that we do
            not operate, such as social media plug-ins. &nbsp;If you visit a third-party
            website or service via a link on the Services, you are subject to that third
            party's privacy practices and policies. This Privacy Policy does not apply to
            any Personal Information that you provide to third-party websites or services.
            &nbsp;A link to a third-party website or service does not mean that we endorse
            that third party or the quality or accuracy of the information presented on
            its website or service.
          </p>

          <p>
            <b>
              9.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;NOTICE
              TO INTERNATIONAL VISITORS
            </b>
          </p>

          <p>
            The Services are controlled and operated by us from the United States, and are
            not intended to subject us to the laws or jurisdiction of any state, country
            or territory other than the United States. &nbsp;Your Personal Information may
            be stored and processed in any country where we have facilities or in which we
            engage service providers. &nbsp;By using the Services, you consent to the
            transfer of information to countries outside of your country of residence,
            including the United States, which may have different data protection rules
            than those of your country.
          </p>

          <p>
            <b>
              10.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SECURITY
            </b>
          </p>

          <p>
            We take reasonable precautions intended to help protect the Personal
            Information that we collect and store; however, no system or online
            transmission of data is completely secure. &nbsp;We cannot guarantee the
            security of information transmitted to or through the Services. &nbsp;Any
            transmission is at your own risk. &nbsp;Please use security measures to
            protect your Personal Information.
          </p>

          <p>
            <b>
              11.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CHILDREN'S
              PRIVACY
            </b>
          </p>

          <p>
            The Services are not directed to or intended for use by minors.
            &nbsp;Consistent with the requirements of the US Children's Online Privacy
            Protection Act, if we learn that we have received information directly from a
            child under age 13 without his or her parent or legal guardian's verified
            consent, we will use that information only to respond directly to that child
            (or his or her parent or legal guardian) to inform the child that he or she
            cannot use the Services. &nbsp;Subsequently, we will make commercially
            reasonable efforts to delete such information.
          </p>

          <p>
            <b>
              12.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;QUESTIONS
              OR COMMENTS
            </b>
          </p>

          <p>
            We welcome your questions and comments about this Privacy Policy or how we
            process your Personal Information. Please contact us using the information
            below, and we will respond to you as soon as reasonably possible.
          </p>

          <p>
            <b>Contact NAPLES MLS at:</b>
          </p>

          <div>
            <p>
              M.L.S. of NAPLES, Inc.
              <br />
              1455 Pine Ridge Road
              <br />
              Naples, FL&nbsp; 34109----
              <br />
              239-597=1666
              <br />
              gdpr.compliance@nabor.com
            </p>
          </div>

          <p>&nbsp;</p>

          <p>www.naplesarea.com</p>

          <h1>European Economic Area ("EEA") Privacy Policy</h1>

          <p>
            <strong>Effective Date: July 1, 2018</strong>
          </p>

          <p>
            This Privacy Policy applies to NAPLES MLS' offering of goods and services, or
            monitoring the behavior, of individuals located in the EEA.&nbsp; This Privacy
            Policy describes how NAPLES MLS collects and otherwise processes your Personal
            Data (as defined below) in connection with:
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Your use of our website, including
            www.naplesarea.com, and mobile applications;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Subscriptions to our newsletters and
            other marketing messages;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Invitations to and participation in our
            webinars, seminars, and other events;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; User communications and activities;
          </p>

          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Recruitment processes;</p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Customer and potential customer
            matters; and
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Procurement and potential procurement
          </p>

          <p>
            For any other use of your Personal Data, please refer to our
            general&nbsp;Privacy Policy.
          </p>

          <h1>NAPLES MLS AS DATA CONTROLLER:</h1>

          <p>
            "<b>M.L.S. of</b> <strong>NAPLES, Inc.</strong>" or "
            <strong>NAPLES MLS</strong>" refers to one of the following entities: NAPLES
            MLS, Inc. (US), or Naples Area Board of Realtors ("NABOR"), (each, an "
            <strong>Entity</strong>" or together, "<strong>Entities</strong>").
          </p>

          <p>
            This Privacy Policy is provided on behalf of each NAPLES MLS Entities, and the
            NAPLES MLS Entities are not joint controllers with regard to Personal Data
            collected under this Privacy Policy.&nbsp; Depending on the type of or
            location where legal or other services are provided, different Entities may be
            the data controller in relation to your Personal Data.&nbsp; The data
            controller ("
            <strong>we</strong>", "<strong>us</strong>", "<strong>our</strong>") is the
            Entity named when we collect your Personal Data or in the location where
            NAPLES MLS referred you to this Privacy Policy (e.g., the Entity identified a
            link to this Privacy Policy).
          </p>

          <p>
            If no Entity has been clearly identified, the data controller or data
            controllers may be identified in the following order or precedence:
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; For Personal Data that NAPLES MLS
            collects on or through its websites, including www.naplesarea.com, and mobile
            applications, NAPLES MLS, Inc. is the data controller.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; For Personal Data that is collected in
            connection with our newsletters and other marketing message, the data
            controller is identified on the subscription form and in each message.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; For Personal Data collected in
            connection with invitations and participation in our webinars, seminars, and
            other events, the data controller will be the Entity which is organizing such
            event as identified in the invitation.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; For customer or subscriber
            communications and activities, the data controller is the Entity that is
            identified in the respective communication or in the context of the activity.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; For Personal Data collected in the
            context of a recruitment process, the data controller is the Entity identified
            in the job posting or otherwise seeking to source a position.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; For Personal Data that NAPLES MLS
            collects pursuant to a client or contractor relationship, the NAPLES MLS
            entity with which you have the client or contractor relationship is the data
            controller.&nbsp; Note that NAPLES MLS is an independent data controller with
            regard to Personal Data we obtain through our client relationships; NAPLES MLS
            will not be a data processor for our clients.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; For activities in the context of the
            procurement of products and services, the data controller will be the Entity
            identified in the order form, agreement, or similar document.
          </p>

          <p>
            If you have any doubt about the controller or controllers of your Personal
            Data, please contact us using the information in the section "Contact us" at
            the end of this Privacy Policy.
          </p>

          <h1>PERSONAL DATA WE PROCESS:</h1>

          <p>
            "<strong>Personal Data</strong>" refers to any information that relates to you
            directly or indirectly or any other "personal data" as defined in
            Article&nbsp;4 point&nbsp;1 of Regulation (EU) 2016/679 (General Data
            Protection Regulation) ("
            <strong>GDPR</strong>"). We process the following categories of Personal Data:
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Contact information</b>
            </em>
            , such as your name, home or business address, email address, and phone
            number, social media handles, and business contact information;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Client information</b>
            </em>
            , which includes information provided or made available to us by or on behalf
            of our clients and information generated by us in the course of providing
            services to our clients;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Technical information</b>
            </em>
            , such as data collected about your interaction with our websites, mobile
            applications, and email communications;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Financial information</b>
            </em>
            , such as payment card and related information;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Recruitment information</b>
            </em>
            , such as curriculum vitae/resume, work history, and qualifications;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Identification or background information</b>
            </em>
            &nbsp;provided by you or collected by us or third parties as part of our
            recruitment, engagements, business analysis, client onboarding, regulatory
            compliance checks, and related processes; and
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Any other information that you provide
            us that can be used to identify you.
          </p>

          <p>We collect Personal Data from:</p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Direct interactions</b>
            </em>
            , such as<strong>&nbsp;</strong>when you enquire about our services, provide
            us your contact details, register for an event with us, provide us with
            information in connection with our services, participate in surveys or
            questionnaires, subscribe to newsletter and blog updates, post comments on our
            blogs, or in any way engage with us or our personnel;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Cookies and automated technologies</b>
            </em>
            , such as when you interact with our website, mobile applications or click on
            links on our emails;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Mobile applications</b>
            </em>
            , such as when you use mobile applications that we may offer as part of our
            services or at certain events hosted by NAPLES Entities;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Private third party sources</b>
            </em>
            , such as<strong>&nbsp;</strong>when third parties, including other
            construction companies, contractors, or clients provide information to us;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Through social media</b>
            </em>
            , such as<strong>&nbsp;</strong>if you link to social media platforms or use
            social media plug-ins, we may (depending on your user privacy settings on that
            social media platform) automatically receive information about you from that
            social media platform; and
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <em>
              <b>Public sources</b>
            </em>
            , such as when we need to collect your Personal Data from publicly available
            sources including, government and law enforcement agencies, companies and land
            registries.
          </p>

          <h1>HOW WE USE YOUR PERSONAL DATA:</h1>

          <h2>Personal Data we obtain through the operation of our websites:</h2>

          <p>
            We use Personal Data in the course of and in connection with the services we
            provide to our participants, subscribers, and customers, and users of our
            websites ("End Users").&nbsp; The legal basis for processing such data will
            generally be our legitimate interest in providing information and services to
            our End Users or to establish, exercise or defend legal claims of our End
            Users (Article&nbsp;6(1)(f) GDPR).&nbsp; We will process identification and
            background information as part of our services or vendor engagement
            activities, including reputational and financial checks.&nbsp; We will also
            process Personal Data provided to us by or on behalf of our End Users for the
            purposes of the information and services we provide to them or on their
            behalf.&nbsp; Personal Data may be disclosed to third parties to the extent
            necessary in connection with the information or services provided to our End
            Users.
          </p>

          <h2>
            <b>
              Personal Data we obtain in the provision of information or services to our
              End Users:
            </b>
          </h2>

          <p>
            Below is a description of the Personal Data we obtain in the provision of
            information or services to our End Users, the likely source of the Personal
            Data, how we may use it, and for what purposes and pursuant to what legal
            basis.
          </p>

          <table border="1" cellSpacing="0" cellPadding="0">
            <thead>
              <tr>
                <td valign="top">
                  <p>
                    <strong>Use of your Personal Data</strong>
                  </p>
                </td>
                <td valign="top">
                  <p>
                    <strong>Categories of Personal Data we Process</strong>
                  </p>
                </td>
                <td valign="top">
                  <p>
                    <strong>Source of the Personal Data</strong>
                  </p>
                </td>
                <td valign="top">
                  <p>
                    <strong>Legal Basis</strong>
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td valign="top">
                  <p>
                    Obtain your subscription preferences and send eNewsletters and similar
                    marketing communications
                  </p>
                </td>
                <td valign="top">
                  <p>
                    Contact information and other information you provide, such as your
                    topic preferences and areas of interests
                  </p>
                </td>
                <td valign="top">
                  <p>You</p>
                </td>
                <td valign="top">
                  <p>
                    Legitimate Interest: To provide you with information you need and
                    other services you request and to efficiently communicate with our
                    client where you are the client or contact person for our client
                    (Article&nbsp;6(1)(f) GDPR)
                  </p>
                </td>
              </tr>
              <tr>
                <td valign="top">
                  <p>Respond to inquiries and fulfill requests</p>
                </td>
                <td valign="top">
                  <p>
                    Contact information and other information you provide, such as your
                    requests
                  </p>
                </td>
                <td valign="top">
                  <p>You</p>
                </td>
                <td valign="top">
                  <p>
                    Legitimate Interest: To provide you with information you need and
                    other services you request and to efficiently communicate with our
                    client where you are the client or contact person for our client
                    (Article&nbsp;6(1)(f) GDPR)
                  </p>
                  <p>
                    Consent: We will send you marketing communications by email and
                    text/SMS pursuant to your consent (Article&nbsp;6(1)(a) GDPR)
                  </p>
                  <p>
                    Contract: If you are our End User or prospective End User
                    (Article&nbsp;6(1)(b) GDPR)
                  </p>
                </td>
              </tr>
              <tr>
                <td valign="top">
                  <p>Conduct surveys and questionnaires</p>
                </td>
                <td valign="top">
                  <p>
                    Contact information and other information you provide, such as your
                    survey answers
                  </p>
                </td>
                <td valign="top">
                  <p>You</p>
                </td>
                <td valign="top">
                  <p>
                    Legitimate interests: To evaluate and take action with regard to your
                    feedback and comments about NAPLES MLS's services
                    (Article&nbsp;6(1)(f) GDPR)
                  </p>
                  <p>
                    Contract: If you are our End User or prospective End User
                    (Article&nbsp;6(1)(b) GDPR)
                  </p>
                </td>
              </tr>
              <tr>
                <td valign="top">
                  <p>
                    Register for online and in person events and deliver event-related
                    materials
                  </p>
                </td>
                <td valign="top">
                  <p>
                    Contact information other information you provide, such as your
                    preferences for the event
                  </p>
                </td>
                <td valign="top">
                  <p>You</p>
                </td>
                <td valign="top">
                  <p>
                    Legitimate interests: To enable your attendance at our events and to
                    deliver you event materials (Article&nbsp;6(1)(f) GDPR)
                  </p>
                  <p>
                    Contract: As may be described on the registration page for the event
                    (Article&nbsp;6(1)(a) GDPR)
                  </p>
                </td>
              </tr>
              <tr>
                <td valign="top">
                  <p>Obtain current contact data and update contact records in our CRM</p>
                </td>
                <td valign="top">
                  <p>
                    Contact information and other information you provide, such as your
                    relationships to people at NAPLES MLS
                  </p>
                </td>
                <td valign="top">
                  <p>You and public sources, such as LinkedIn</p>
                </td>
                <td valign="top">
                  <p>
                    Legitimate interests: To ensure the integrity of our End User and
                    other contact data (Article&nbsp;6(1)(f) GDPR)
                  </p>
                </td>
              </tr>
              <tr>
                <td valign="top">
                  <p>Perform website analytics</p>
                </td>
                <td valign="top">
                  <p>
                    Technical information and other information we collect
                    &nbsp;demographics, interests, behavior tracking, event tracking
                  </p>
                </td>
                <td valign="top">
                  <p>First and third party analytics cookies</p>
                </td>
                <td valign="top">
                  <p>
                    Legitimate interests: To understand more about our website visitors
                    (what pages you view, how long you visit, your devices, etc.) in order
                    to improve our services (Article&nbsp;6(1)(f) GDPR)
                  </p>
                </td>
              </tr>
            </tbody>
          </table>

          <br />
          <br />
          <h2>
            <b>Other Uses:</b>
          </h2>

          <p>
            Any other purposes for which we wish to use your Personal Data that are not
            listed above, or any other changes we propose to make to the existing purposes
            will be notified to you by amending this Privacy Policy in accordance with the
            Section titled "Changes to this Privacy Policy" below.
          </p>

          <h1>HOW WE SHARE YOUR PERSONAL DATA:</h1>

          <p>
            We will share your Personal Data within the same NAPLES MLS Entity to which
            you provided it, with other NAPLES MLS Entities as may be required, with data
            processors, and with other data controllers.&nbsp; We may also transfer your
            Personal Data outside of the EEA.
          </p>

          <h2>
            <b>Recipients within the same NAPLES MLS Entity:</b>
          </h2>

          <p>
            Your Personal Data will be used by our partners, employees and other staff
            members for the purposes described above and for accounting, tax and other
            administrative purposes.
          </p>

          <h2>
            <b>Recipients within other NAPLES MLS Entities:</b>
          </h2>

          <p>
            Your Personal Data will be used by our partners, employees, and other staff
            members for the purposes described above and for accounting, tax and other
            administrative purposes.
          </p>

          <h2>
            <b>Data Processors:</b>
          </h2>

          <p>
            We engage other NAPLES MLS Entities (in particular, NABOR) as well as
            third-party service providers for the provision of services that help us in
            processing Personal Data and providing services to our End Users.&nbsp; These
            third parties will process your Personal Data as data processors
            (Article&nbsp;28 GDPR) solely on our behalf.&nbsp; The categories of such
            recipients include:
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; service providers for information
            technology and telecommunications (such as data centers, hosting providers,
            email service providers;
          </p>

          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; marketing service providers;</p>

          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; accounting service providers;</p>

          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; corporate services providers;</p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; trustee and nominee service providers;
          </p>

          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; incorporation service providers;</p>

          <p>- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; cyber security providers; and</p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; business process outsourcing providers.
          </p>

          <h2>
            <b>Other Controllers:</b>
          </h2>

          <p>In addition, we may share your Personal Data with:</p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Any party for whom your consent has
            been provided or other legal basis obtained, including companies we introduce
            you to or companies with whom you ask us to share your Personal Data;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Third-party real estate, mortgage
            lending, title insurers, or other companies that provide services incident to
            the sale or ownership of real property;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Third parties, if necessary in relation
            to a merger, sale, acquisition, divesture, restructuring, reorganization,
            dissolution, bankruptcy, or other change of ownership or control (whether in
            whole or in part); and
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Third parties, if we determine that the
            disclosure is necessary: (i) to comply with any law applicable to us, a
            request from law enforcement, a regulatory agency, or other legal process;
            (ii) to protect the legitimate rights, privacy, property, interests or safety
            of NAPLES MLS, our End Users, business partners, personnel, or the general
            public; (iv) to pursue available remedies or limit damages; (v) to enforce our
            Terms of Use; or (vi) to respond to an emergency.
          </p>

          <h1>International Transfer of Personal Data</h1>

          <p>
            NAPLES MLS is committed to complying with this Privacy Policy and European
            data protection laws with regard to information transferred from the EEA. The
            laws in the United States and other countries outside the EEA may not be as
            protective as the laws in Europe.&nbsp; Because of this, NAPLES MLS has taken
            steps to protect your privacy and fundamental rights when your Personal Data
            is transferred to the United States (and to other countries where no adequacy
            decision of the European Commission exists).&nbsp; For transfers to NAPLES MLS
            Entities outside the EEA, we make use of the European Commission's Standard
            Contractual Clauses.&nbsp; For transfers to third parties, we make sure that
            the either recipient is subject to a jurisdiction for which an adequacy
            decision of the European Commission (including the EU-U.S. Privacy Shield
            where the recipient is a participant), or that there are adequate safeguards
            such as the Standard Contractual Clauses or binding corporate rules in place.
          </p>

          <p>
            If you would like to know more about how we protect your Personal Data, or
            obtain a copy of the adequate safeguards, you can contact us using the
            information in the section "Contact Us" at the end of this Privacy Policy.
          </p>

          <h1>Use of our Website:</h1>

          <p>
            This section only applies to the use of our website at www.naplesarea.com from
            the EEA.
          </p>

          <h2>
            <b>Cookies and Other Data Collection Technology:</b>
          </h2>

          <p>
            A&nbsp;<strong>"Cookie"</strong>&nbsp;is a small text file that is sent to or
            accessed from your web browser or your computer's hard drive. A Cookie
            typically contains the name of the domain (internet location) from which the
            Cookie originated, the "lifetime" of the Cookie (when it expires), and a
            randomly generated unique number or other similar identifier. A Cookie may
            also contain information about your computer, such as user settings, browsing
            history and activities conducted while using our online services.
          </p>

          <p>
            A&nbsp;<strong>"Web Beacon"</strong>&nbsp;(also called a&nbsp;
            <strong>"</strong>pixel tag<strong>"</strong>&nbsp;or&nbsp;
            <strong>"</strong>
            clear GIF<strong>"</strong>) is a piece of computer code that enables us to
            monitor user activity and website traffic.
          </p>

          <p>
            We refer to Cookies, web beacons (also known as pixel tags and clear GIFs) and
            other similar technology as&nbsp;
            <strong>"Data Collection Technology</strong>.<strong>"</strong>
            &nbsp;&nbsp; To learn more about cookies and web beacons,
            visit&nbsp;www.allaboutcookies.org.
          </p>

          <p>
            Data Collection Technology helps us improve your experience on our online
            services. For example, we may use Google Analytics, a web-based analytics tool
            that tracks and reports on the manner in which the website is used to help us
            to improve it.&nbsp; Google Analytics does this by placing Cookies on your
            device.&nbsp; The information that the Cookies collect, such as the number of
            visitors to the website, the pages visited and the length of time spent on the
            website, is aggregated.&nbsp; We also may use Data Collection Technology to
            collect information from the computer or device that you use to access our
            online services, such as your operating system type, browser type, domain and
            other system settings, as well as the language your system uses and the
            country and time zone in which your computer or device is located.
          </p>

          <p>
            We generally use the following types of Data Collection Technologies, which
            may change from time to time
          </p>

          <table border="1" cellSpacing="0" cellPadding="0">
            <thead>
              <tr>
                <td valign="top">
                  <p>
                    <strong>Description</strong>
                  </p>
                </td>
                <td valign="top">
                  <p>
                    <strong>Cookie Name</strong>
                  </p>
                </td>
                <td valign="top">
                  <p>
                    <strong>Category</strong>
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td valign="top">
                  <p>
                    Cookies used to maintain the session of the user from page to page
                  </p>
                </td>
                <td valign="top">
                  <p>__cfduid</p>
                </td>
                <td valign="top">
                  <p>Session cookie</p>
                </td>
              </tr>
              <tr>
                <td valign="top">
                  <p>Cookies used to track the number of users on our site</p>
                </td>
                <td valign="top">
                  <p>_ga</p>
                  <p>_gat_UA-3272219-1</p>
                  <p>_gid</p>
                  <p>siteimproveses</p>
                  <p>_global_lucky_opt_out</p>
                  <p>_lo_uid</p>
                  <p>_lo_rid</p>
                  <p>_lo_v</p>
                  <p>__lotr</p>
                </td>
                <td valign="top">
                  <p>Third party (Google Analytics, Lucky Orange) analytics cookie</p>
                </td>
              </tr>
            </tbody>
          </table>

          <p>
            <strong>Your Control of Cookies:</strong>
          </p>

          <p>
            Some web browsers (including some mobile web browsers) provide settings that
            allow you to control or reject Cookies or alert you when a Cookies is placed
            on your device. You may also be able to reject mobile device identifiers by
            activating the appropriate setting on your mobile device. Although you are not
            required to accept Cookies or mobile device identifiers, if you block or
            reject them, you may not have access to all features available through our
            online services.
          </p>

          <p>&nbsp;</p>

          <p>
            <strong>Our Policy on Do Not Track Signals:</strong>
          </p>

          <p>
            Some web browsers incorporate a "Do Not Track" (<strong>"DNT"</strong>) or
            similar feature that signals to websites that a user does not want to have his
            or her online activity and behavior tracked.&nbsp; If a website that responds
            to a particular DNT signal receives the DNT signal, the browser can block that
            website from collecting certain information about the browser's user.&nbsp; We
            follow the DNT signals we receive from your browsers.
          </p>

          <h2>
            <b>LINKS TO THIRD PARTY WEBSITES AND SERVICES:</b>
          </h2>

          <p>
            Our services may include links or references to third party websites and
            services that we do not operate or control.&nbsp; If you provide your Personal
            Data to that third party through its websites or services, you will be subject
            to that third party's privacy practices and policies.&nbsp; This Privacy
            Policy does not apply to any Personal Data that you provide to a third party
            website or service.&nbsp; We recommend that you read the Privacy Policy that
            applies to that third party website or service.&nbsp; A link or reference to a
            third party website or service does not mean that we endorse that third party
            or the quality or accuracy of the information presented on its website or
            service.
          </p>

          <h1>SECURITY:</h1>

          <p>
            We implement appropriate technical and organizational measures designed to
            ensure your Personal Data in protected from unauthorized access, use,
            disclosure, alteration or destruction, in accordance with applicable laws and
            regulations.&nbsp; For example:
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Limiting access of your Personal Data
            to authorized&nbsp; parties;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Limiting our collection and use of your
            Personal Data to the extent necessary to provide you with our services;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; If we outsource processing of Personal
            Data to third parties, basing our selection on said third parties having
            adequate safeguards in place that meet our data protection and security
            standards, and regularly auditing their compliance with applicable data
            protection policies, laws and regulations;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Having systems in place designed to
            ensure that we can restore the availability and access to Personal Data in the
            event of a physical or technical incident;
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Periodically inspecting, assessing, and
            evaluating the effectiveness of our technical and organizational measures
            designed to ensure the security of our processing; and
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Regularly training our personnel on
            data protection and cybersecurity.
          </p>

          <p>
            If you would like to know more about how we protect your Personal Data, you
            can contact us using the information in the section "Contact Us" at the end of
            this Privacy Policy.
          </p>

          <h1>RETENTION OF PERSONAL DATA:</h1>

          <p>
            We will keep your Personal Data for as long as necessary to fulfill the
            purposes we collected it for, including any legal, accounting or reporting
            requirements.&nbsp; To determine the appropriate retention period for Personal
            Data, we consider the amount, nature, and sensitivity of Personal Data, the
            potential risk of harm from unauthorized use or disclosure of your Personal
            Data, the purposes for which we process your Personal Data, whether we can
            achieve those purposes through other means, and all applicable legal
            requirements.
          </p>

          <h1>CHILDREN'S PRIVACY:</h1>

          <p>
            Our services are not directed to or intended for use by minors.&nbsp;
            Consistent with the requirements of the US Children's Online Privacy
            Protection Act, the GDPR, and all other applicable laws and regulations, if we
            learn that we have received information directly from a child under age 13
            without his or her parent or legal guardian's verified consent, we will use
            that information only to respond directly to that child (or his or her parent
            or legal guardian) to inform the child that he or she cannot use our Services.
            Subsequently, we will delete such information.
          </p>

          <h1>MARKETING:</h1>

          <p>
            If you do not wish to receive marketing-related emails from us, please click
            the unsubscribe link at the bottom of a marketing email, or email us using the
            information in the section "Contact Us" at the end of this Privacy
            Policy.&nbsp; You may unsubscribe from certain marketing topics while staying
            subscribed to other marketing topics.&nbsp; If you choose to unsubscribe from
            all marketing emails, that unsubscribe request will apply across all NAPLES
            MLS Entities.&nbsp; Please note that even if we stop all marketing
            communications, you may still receive administrative, legal, and other
            important communications from us.
          </p>

          <h1>YOUR RIGHTS:</h1>

          <p>
            Under the GDPR, you have the following rights regarding your Personal Data
            that we process:
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>Right to access</strong>&nbsp;to the following information:
            (a)&nbsp;the purposes of the processing; (b)&nbsp;the categories of Personal
            Data concerned; (c)&nbsp;the recipients or categories of recipient to whom the
            Personal Data have been or will be disclosed, in particular recipients in
            third countries or international organizations; (d)&nbsp;where possible, the
            envisaged period for which the Personal Data will be stored, or, if not
            possible, the criteria used to determine that period; (e)&nbsp;the existence
            of the right to request from the controller rectification or erasure of
            Personal Data or restriction of processing of Personal Data concerning the
            data subject or to object to such processing; (f)&nbsp;the right to lodge a
            complaint with a supervisory authority; (g) where the Personal Data has not
            been collected from you, any available information as to their source;
            (h)&nbsp;the existence of automated decision-making, including profiling,
            referred to in Article 22(1) and (4) of the GDPR and, at least in those cases,
            meaningful information about the logic involved, as well as the significance
            and the envisaged consequences of such processing for the data subject
            (Article&nbsp;15 of the GDPR).
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>Right to rectification</strong>&nbsp;of inaccurate Personal Data
            concerning you under as well as, taking into account the purposes of the
            processing, the right to have incomplete Personal Data completed, including by
            means of providing a supplementary statement (Article&nbsp;16 of the GDPR).
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>Right to erasure</strong>&nbsp;(deletion) of Personal Data concerning
            you without undue delay where: (a)&nbsp;the Personal Data is no longer
            necessary in relation to the purposes for which they were collected or
            otherwise processed; (b)&nbsp;you withdraw your consent and there are no other
            legal grounds for the processing; (c)&nbsp;you exercise your right to object
            (see below) and there are no compelling legitimate grounds for the processing;
            (d)&nbsp;the Personal Data have been unlawfully processed; or (e)&nbsp;the
            Personal Data have to be erased for compliance with a legal obligation
            applicable to us (Article&nbsp;17 of the GDPR).
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>Right to restriction of processing</strong>&nbsp;(i.e., Personal Data
            will be blocked from normal processing but not erased) where: (a)&nbsp;you
            contest the accuracy of the Personal Data, for a period enabling us to verify
            the accuracy; (b)&nbsp;the processing is unlawful and you oppose the erasure
            of the Personal Data and requests the restriction of their use instead;
            (c)&nbsp;we no longer need the Personal Data for the purposes of the
            processing but they are required by you for the establishment, exercise or
            defense of legal claims; (d)&nbsp;you exercise your right to object (see
            below) pending the verification whether our legitimate grounds override those
            of you (Article&nbsp;18 of the GDPR).
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Where processing is based on your
            consent, the&nbsp;<strong>right to withdraw consent</strong>
            &nbsp;at any time, without affecting the lawfulness of the processing prior to
            such withdrawal (Article&nbsp;7(3) of the GDPR).&nbsp; Please note that even
            after you have chosen to withdraw your consent we may be able to continue to
            process your Personal Data, in some limited circumstances, to the extent
            required or otherwise permitted by law, or in connection with exercising and
            defending our legal rights or meeting our legal and regulatory obligations.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Where processing is based on your
            consent, or on a contract, the&nbsp;
            <strong>right to data portability</strong>, i.e. the right to obtain a copy of
            the Personal Data concerning you in a structured, commonly used and
            machine-readable format and the right to transmit those data to another
            controller without hindrance from us.
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>Right&nbsp;to object</strong>&nbsp;to the processing of Personal Data
            based on legitimate interests of us, other NAPLES MLS Entities or any third
            party under Article&nbsp;21 of the GDPR based on your particular situation,
            provided that there are no compelling legitimate grounds for the processing
            that would override your interests, rights and freedoms or for the
            establishment, exercise or defense of legal claims (Article&nbsp;21 of the
            GDPR).
          </p>

          <p>
            If you wish to exercise any of your rights above, please contact us using the
            information in the section "Contact Us" at the end of this Privacy Policy. We
            may charge you a reasonable fee in case you request additional copies of your
            Personal Data or make other requests that are manifestly unfounded or
            excessive.&nbsp; If we are unable to honor your request, or before we charge a
            fee, we will let you know why.&nbsp; In so far as practicable and required
            under law, we will notify third parties with whom we have shared your Personal
            Data of any request for correction, deletion, and/or restriction to the
            processing of your Personal Data.&nbsp; Please note that we cannot guarantee
            third parties will comply with your requests and we encourage you to contact
            those third parties directly.
          </p>

          <p>
            Please note that if you decide to exercise some of your rights, we may be
            unable to perform the actions necessary to achieve the purposes set out above
            or you may not be able to use or take full advantage of the services and
            information we offer.
          </p>

          <p>
            We must ensure that your Personal Data is accurate and up to date.&nbsp;
            Therefore, please advise us of any changes to your information by emailing us
            here.
          </p>

          <h1>CHANGES TO THIS PRIVACY POLICY:</h1>

          <p>
            The Effective Date of this Privacy Policy is set forth at the top of this
            webpage. If we materially change the way we collect, use or disclose your
            Personal Data we will notify you in advance by email and/or by placing a
            prominent notice on this website. The amended Privacy Policy supersedes all
            previous versions.
          </p>

          <h1>
            <a name="_Ref514583384">Contact us:</a>
          </h1>

          <p>
            We welcome your questions and comments about this Privacy Policy or how we
            process your Personal Data.&nbsp; Please contact each of our Entities who are
            the data controller using contact information displayed on our Legal
            Notices/Imprint section below, and we will respond to you as soon as
            reasonably possible.
          </p>

          <p>
            You always have the right to lodge a complaint with your local competent
            supervisory authority or any authority that applies to the NAPLES MLS
            Entities.
          </p>

          <p>
            <strong>United States:</strong>
          </p>
          <p>
            <strong>NAPLES MLS, Inc.</strong>&nbsp;(United States) has named a data
            protection officer&nbsp;for processing activities where it is the data
            controller.&nbsp; You may contact the data protection officer using the
            contact information below:
          </p>

          <p>By Phone:+1 (239)-597-1666 </p>

          <p>By Email:gdpr.compliance@nabor.com</p>

          <h2>
            <b>Global Privacy Office:</b>
          </h2>

          <p>
            In addition, you may contact our global Privacy Office for any of the NAPLES
            MLS Entity using the contact information below:
          </p>

          <p>&nbsp;</p>

          <p>
            M.L.S .of NAPLES, Inc.
            <br />
            1455 Pine Ridge Road
            <br />
            Naples, FL&nbsp; 34109
          </p>

          <p>gdpr.compliance@nabor.com</p>

          <h1>LegalNotices / Imprint</h1>

          <p>The website at www.naplesarea.com is operated by:</p>

          <p>
            Address:&nbsp;&nbsp;M.L.S. of Naples, Inc.
            <br />
            1455 Pine Ridge Road
            <br />
            Naples, FL 34109
          </p>

          <p>Phone:&nbsp;+1 239-597-1666</p>

          <p>Email:&nbsp;&nbsp;gdpr.compliance@nabor.com</p>

          <p>
            M.L.S. of Naples, Inc. is a Florida for profit corporation with its office
            located as set forth above.
          </p>

          <p>
            For information on how we handle your personal information, please refer to
            our "Privacy Policy".
          </p>

          <p>
            <b>AFFILIATED ENTITIES</b>
          </p>

          <p>
            The following affiliated entities are collectively referred to as "NAPLES MLS,
            Inc.," or "NAPLES MLS":
          </p>

          <p>
            - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The Naples Area Board of REALTORS¨
            (NABOR), a Florida not for profit corporation with offices at the same address
            as the M.L.S. of Naples, Inc.&nbsp; The M.L.S. of Naples, Inc. is wholly owned
            by NABOR.
          </p>

          <p>
            The M.L.S. of Naples, Inc. and NABOR coordinate their activities through
            service agreements.
          </p>
        </Container>
      </Container>
    );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/containers/PrivacyPolicy/PrivacyPolicy.js